import { render, staticRenderFns } from "./InviteModal.vue?vue&type=template&id=560a5ff3&"
import script from "./InviteModal.vue?vue&type=script&lang=js&"
export * from "./InviteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports